import { render, staticRenderFns } from "./SegmentListCreateOrEditStatusFilter.vue?vue&type=template&id=18b1ca0b&scoped=true&"
import script from "./SegmentListCreateOrEditStatusFilter.vue?vue&type=script&lang=js&"
export * from "./SegmentListCreateOrEditStatusFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1ca0b",
  null
  
)

export default component.exports